const homeSlider = () => {
  function lerp(a, b, t) {
    return Math.round(a * (1 - t) + b * t);
  }
  function setVendor(elem, value) {
    elem.style.transform = value;
    elem.style.webkitTransform = value;
    elem.style.mozTransform = value;
    elem.style.msTransform = value;
    elem.style.oTransform = value;
  }
  const slider = document.querySelector(".js-home-slider");
  if (!slider) return;
  const sliderAbsolute = document.querySelector(".js-home-slider-absolute");
  const sliderInner = document.querySelector(".js-home-slider-inner");
  const slides = [...document.querySelectorAll(".js-home-slide")];
  let sliderTransform = 0;
  let isMouseDown = false;
  let moveX = 0;
  let startingPositionX = 0;
  let deltaX = 0;
  let amountMovedX = 0;
  let amountAndDelta = 0;
  let direction = "left";

  slides.forEach((slide) => {
    const newSlide = slide.cloneNode(true);
    sliderInner.insertAdjacentElement("beforeend", newSlide);
  });
  slides.forEach((slide) => {
    const newSlide = slide.cloneNode(true);
    sliderInner.insertAdjacentElement("beforeend", newSlide);
  });

  let sliderWidth = sliderInner.getBoundingClientRect().width / 3;

  window.addEventListener("resize", () => {
    sliderWidth = sliderInner.getBoundingClientRect().width / 3;
  });

  const handleDraging = (e) => {
    let posX = e.clientX || e.changedTouches[0].clientX;
    isMouseDown = true;
    startingPositionX = posX;
    deltaX = 0;
  };

  const stopDrag = (e) => {
    let posX = e.clientX || e.changedTouches[0].clientX;
    if (isMouseDown) {
      if (startingPositionX > posX) {
        direction = "left";
      } else {
        direction = "right";
      }
    }
    isMouseDown = false;
    amountMovedX += deltaX;
    deltaX = 0;
  };

  sliderInner.addEventListener("mousedown", (e) => handleDraging(e));
  sliderInner.addEventListener("touchstart", (e) => handleDraging(e));
  window.addEventListener("mouseup", (e) => stopDrag(e));
  window.addEventListener("touchend", (e) => stopDrag(e));
  window.addEventListener("touchcancel", (e) => stopDrag(e));

  window.addEventListener("mousemove", (e) => {
    if (!isMouseDown) return;
    deltaX = startingPositionX - e.clientX;
  });
  window.addEventListener("touchmove", (e) => {
    if (!isMouseDown) return;
    deltaX = startingPositionX - e.changedTouches[0].clientX;
  });

  // Throttling at 60 FPS
  const fpsInterval = 1000 / 60;
  let now = Date.now();
  let then = Date.now();
  let elapsed;

  function animate() {
    requestAnimationFrame(animate);
    now = Date.now();
    elapsed = now - then;
    if (elapsed > fpsInterval) {
      then = now - (elapsed % fpsInterval);
      if (isMouseDown) {
        amountAndDelta = amountMovedX + deltaX;
        if (direction === "left") {
          sliderTransform += 0.2;
        } else {
          sliderTransform -= 0.2;
        }
      } else {
        if (direction === "left") {
          sliderTransform += 1;
        } else {
          sliderTransform -= 1;
        }
      }

      if (sliderTransform >= sliderWidth) {
        sliderTransform = 0;
      }
      if (sliderTransform < 0) {
        sliderTransform = sliderWidth;
      }
      setVendor(slider, `translateX(${-sliderTransform}px)`);

      moveX = lerp(moveX, amountAndDelta, 0.1);
      if (moveX < 0) {
        moveX += sliderWidth;
        amountMovedX += sliderWidth;
        amountAndDelta += sliderWidth;
      }
      setVendor(sliderAbsolute, `translateX(${-moveX % sliderWidth}px)`);
    }
  }
  animate();
};

export default homeSlider;
